module.exports = __webpack_public_path__ + "static/link-buttonaction-dont-bce81f0755b6c2353d8efe2c3942a6d6.png";